export default __webpack_public_path__ + "static/media/mayonesa.3bdded90.png";